import React from "react";
import { connect } from "react-redux";
import { activateAccount } from "../../../store/users/operations";
import { isUpdatingUser } from "../../../store/users/selectors";
import LoadingIndicator from "../../../components/LoadingIndicator";

export class ActivateAccount extends React.Component{
    componentDidMount(){
        this.props.activateAccount(this.props.match.params.token, '/');
    }

    render() {
        return (
            <LoadingIndicator />
        );
    }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  loading: isUpdatingUser(state)
});

const mapDispatchToProps = dispatch => ({
  activateAccount: (token, redirectTo)=>dispatch(activateAccount(token, redirectTo))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivateAccount);
